import { forwardRef, useState } from 'react';
import FormInput from '../FormInput';
import type { ComponentPropsWithoutRef } from 'react';

// ============================================
// Id Types - Internal Types do Backend
// ============================================

// Id (UUID input with validation)
interface IdProps extends Omit<ComponentPropsWithoutRef<'input'>, 'type'> {
    formInputSize?: 'sm' | 'lg';
    rounded?: boolean;
}

const isValidUUID = (uuid: string): boolean => {
    const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
    return uuidRegex.test(uuid);
};

export const FormId = forwardRef<HTMLInputElement, IdProps>(({ formInputSize, rounded, onChange, value, ...props }, ref) => {
    const [error, setError] = useState<string | null>(null);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        if (val && !isValidUUID(val)) {
            setError('UUID inválido');
        } else {
            setError(null);
        }
        onChange?.(e);
    };

    return (
        <div className="space-y-1">
            <FormInput
                {...props}
                ref={ref}
                type="text"
                value={value}
                onChange={handleChange}
                formInputSize={formInputSize}
                rounded={rounded}
                placeholder="xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
                pattern="^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$"
                className={props.className}
            />
            {error && <p className="text-sm text-red-600">{error}</p>}
        </div>
    );
});
FormId.displayName = 'FormId';
// No aliases: consume FormId directly
